import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'reactstrap'
import { Paper, Grid, withStyles, Table, TableContainer, TableHead, TableRow, TableCell, TableBody, TableSortLabel, Box } from '@material-ui/core'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import Thumbnail from '../widgets/Thumbnail'
import DateHelpers from './../../classes/DateHelpers'
import { TableFormats } from '../TableHelpers'
import moment from 'moment'
import TopicHelpers from './../../classes/TopicHelpers'

import Profile from '../../classes/profile'
import './AudienceMediaPlanningComponent.scss'
import { CircularProgress } from '@material-ui/core'
import { PLAN_AFFINITY, PLAN_GENRE, PLAN_PLATFORM, PLAN_PREMIERE, PLAN_TYPE } from '../../constants/commons'
import MediaPlanningOnBoarding from './MediaPlanningOnboarding'
import { HBO, HBO_MAX, HBO_MAX_OR_HBO, HBO_OR_HBO_MAX } from '../../constants/sov'
export default class AudienceMediaPlanningComponent extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    location: PropTypes.object.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    fetchMediaPlan: PropTypes.func.isRequired,
    topicMediaPlan: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    })
  }

  constructor (props) {
    super (props)

    this.state = {
      selectedRows: [],
      selectedColumns: [],
      selectedCells: [],
      rowFilterDependencies: [],
      columnFilterDependencies: [],
      cellFilterDependencies: [],
      calendarData: null
    }
  }

  componentDidMount () {
    this.props.fetchMediaPlan()
    this.reformateResponse()
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.topicMediaPlan !== this.props.topicMediaPlan) {
      this.reformateResponse()
    }
    const {selectedCells, selectedRows, selectedColumns} = this.state
//These 4 variables return boolean to know whether any cell is present in already selected row or col or any row or col is over any selected cells
    let cellOverSelectedRow = this.isRowOrColIntersectCell(selectedCells, selectedRows, true, false, 'row')
    let rowOverSelectedCell = this.isRowOrColIntersectCell(selectedRows, selectedCells, false, true, 'row')
    let cellOverSelectedCol = this.isRowOrColIntersectCell(selectedCells, selectedColumns, true, false, 'col')
    let colOverSelectedCell = this.isRowOrColIntersectCell(selectedColumns, selectedCells, false, true, 'col')

    if (cellOverSelectedRow && prevState.selectedRows === selectedRows && prevState.selectedCells !== selectedCells) {
      let rowsExpectSelectedCells = this.filteredRowOrColOrCellAfterSelection(selectedRows, selectedCells, false, true, 'row')
      this.setState({selectedRows: rowsExpectSelectedCells})
    }
    if (rowOverSelectedCell && prevState.selectedCells === selectedCells && prevState.selectedRows !== selectedRows) {
      let cellsExpectSelectedRow = this.filteredRowOrColOrCellAfterSelection(selectedCells, selectedRows, true, false, 'row')
      this.setState({selectedCells: cellsExpectSelectedRow})
    }
    if (cellOverSelectedCol && prevState.selectedColumns === selectedColumns && prevState.selectedCells !== selectedCells) {
      let colExpectSelectedCells = this.filteredRowOrColOrCellAfterSelection(selectedColumns, selectedCells, false, true, 'cell')
      this.setState({selectedColumns: colExpectSelectedCells})
    }
    if (colOverSelectedCell && prevState.selectedCells === selectedCells && prevState.selectedColumns !== selectedColumns) {
      let cellsExpectSelectedCol = this.filteredRowOrColOrCellAfterSelection(selectedCells, selectedColumns, true, false, 'col')
      this.setState({selectedCells: cellsExpectSelectedCol})
    }
  }

  isRowOrColIntersectCell = (cellOrRowOrCol1, cellOrRowOrCol2, isCellOver, isRowOrColOver, returnBy) => {
    let result = cellOrRowOrCol1.some(function (numOrStr1) {
      if (cellOrRowOrCol2.length) {
        return cellOrRowOrCol2.some(function (numOrStr2) {
          if (returnBy === 'row') {
            return isCellOver ? numOrStr1.startsWith(numOrStr2.toString()) : isRowOrColOver ? numOrStr2.startsWith(numOrStr1.toString()) : null
          } else {
            return isCellOver ? numOrStr1.endsWith(numOrStr2.toString()) : isRowOrColOver ? numOrStr2.endsWith(numOrStr1.toString()) : null
          }
        })
      }
    })
    return result
  }

  filteredRowOrColOrCellAfterSelection = (cellOrRowOrCol1, cellOrRowOrCol2, isCellExpectRowOrCol, isRowOrColExpectCell, returnBy) => {
    let result = cellOrRowOrCol1.filter(function (numOrStr1) {
      return !cellOrRowOrCol2.some(function (numOrStr2) {
        if (returnBy === 'row') {
          return isCellExpectRowOrCol ? numOrStr1.startsWith(numOrStr2.toString()) : isRowOrColExpectCell ? numOrStr2.startsWith(numOrStr1.toString()) : null
        } else {
          return isCellExpectRowOrCol ? numOrStr1.endsWith(numOrStr2.toString()) : isRowOrColExpectCell ? numOrStr2.endsWith(numOrStr1.toString()) : null
        }
      })
    })
    return result
  }

  reformateResponse () {
    let recos = (this.props.topicMediaPlan.details || {}).recommendations
    let tableRowData = TopicHelpers.reformatRecommendations(recos)
    let calendar = TopicHelpers.calendarFormatter(tableRowData)
    this.setState({calendarData: calendar})
  }

  handleCalendarClick = (event, index, key) => {
    //for row selection
    if (this.state.calendarData && this.state.calendarData.length && event.currentTarget.cellIndex === 0 && event.currentTarget.parentNode.rowIndex !== 0) {
      if (this.state.selectedRows.includes(index)) {
        this.setState({
          selectedRows: this.state.selectedRows.filter(el => el !== index)
        })
        if (this.state.rowFilterDependencies.includes(this.state.calendarData[index].channel)) {
          this.setState({
            rowFilterDependencies: this.state.rowFilterDependencies.filter(el => el !== this.state.calendarData[index].channel)
          })
        }
      } else {
        this.setState({
          selectedRows: [...this.state.selectedRows, index],
          rowFilterDependencies: [...this.state.rowFilterDependencies, this.state.calendarData[index].channel]
        })
      }
      if (this.state.calendarData[index].channel === HBO_OR_HBO_MAX || this.state.calendarData[index].channel === HBO_MAX_OR_HBO) {
        this.setState({
          selectedRows: [...this.state.selectedRows, index],
          rowFilterDependencies: [...this.state.rowFilterDependencies, HBO, HBO_MAX]
        })
        const hasHBO = this.state.rowFilterDependencies.includes(HBO)
        const hasHBOMax = this.state.rowFilterDependencies.includes(HBO_MAX)
        if (hasHBO && hasHBOMax) {
          this.setState({
            rowFilterDependencies: this.state.rowFilterDependencies.filter(el => el !== HBO && el !== HBO_MAX),
            selectedRows: this.state.selectedRows.filter(el => el !== index)
          })
        }
      }
      if (this.state.cellFilterDependencies.length) {
        this.state.cellFilterDependencies.map(e => {
          if (this.state.rowFilterDependencies.includes(e.channel)) {
            this.setState({cellFilterDependencies: this.state.cellFilterDependencies.filter(el => !this.state.rowFilterDependencies.includes(el.channel))})
          }
        })
      }
    }
    //for column selection
    if (event.target.parentNode.rowIndex === 0 && event.currentTarget.cellIndex !== 0) {
      if (this.state.selectedColumns && this.state.selectedColumns.includes(key)) {
        this.setState({
          selectedColumns: this.state.selectedColumns.filter(el => el !== key)
        })
      }
      else {
        this.setState({
          selectedColumns: [...this.state.selectedColumns, key]
        })
      }
      if (this.state.columnFilterDependencies.includes(event.target.innerText)) {
        this.setState({
          columnFilterDependencies: this.state.columnFilterDependencies.filter(el => el !== event.target.innerText)
        })
      } else {
        this.setState({
          columnFilterDependencies: [...this.state.columnFilterDependencies, event.target.innerText]
        })
      }
      if (this.state.cellFilterDependencies.length) {
        this.state.cellFilterDependencies.map(e => {
          if (this.state.columnFilterDependencies.includes(e.monthOrYear.toString())) {
            this.setState({cellFilterDependencies: this.state.cellFilterDependencies.filter(el => !this.state.columnFilterDependencies.includes(el.monthOrYear.toString()))})
          }
        })
      }
    }
    //for cell selection
    if (event.currentTarget.cellIndex !==0 && event.currentTarget.parentNode.rowIndex !== 0 && event.target.innerText !== '') {
      const cellDataKey = event.target.getAttribute('data-key')
      if (this.state.selectedCells && this.state.selectedCells.includes(cellDataKey)) {
        this.setState({
          selectedCells: this.state.selectedCells.filter(k => k !== cellDataKey)
        })
      } else {
          this.setState({
          selectedCells: [...this.state.selectedCells, cellDataKey]
          })
        }
        let monthOrYear = TopicHelpers.mediaPlanningCalendarHeader()[event.currentTarget.cellIndex]
        let channel = this.state.calendarData[event.currentTarget.parentNode.rowIndex - 1][Object.keys(this.state.calendarData[event.currentTarget.parentNode.rowIndex - 1])[0]]
        this.setState({
          cellFilterDependencies: [...this.state.cellFilterDependencies, {channel, monthOrYear}]
        })
        const hasObj = this.state.cellFilterDependencies.find(obj => obj.channel === channel && obj.monthOrYear === monthOrYear)
        const hasHbo = this.state.cellFilterDependencies.find(obj => obj.channel === HBO && obj.monthOrYear === monthOrYear)
        const hasHboMax = this.state.cellFilterDependencies.find(obj => obj.channel === HBO_MAX && obj.monthOrYear === monthOrYear)
        if (hasObj) {
          const fill = this.state.cellFilterDependencies.filter(obj => {
            return !(obj.channel === channel && obj.monthOrYear === monthOrYear)
          })
          this.setState({
            cellFilterDependencies: fill
          })
        }
        if (channel === HBO_OR_HBO_MAX || channel === HBO_MAX_OR_HBO) {
          if (this.state.rowFilterDependencies.includes(HBO) || this.state.rowFilterDependencies.includes(HBO_MAX)) {
            this.setState({
              rowFilterDependencies: this.state.rowFilterDependencies.filter(el => el !== HBO && el !== HBO_MAX)
            })
          }
          if (hasHbo && hasHboMax) {
            const filterHbo = this.state.cellFilterDependencies.filter(obj =>{
              return !((obj.channel === HBO || obj.channel === HBO_MAX) && obj.monthOrYear === monthOrYear)
            })
            this.setState({
              cellFilterDependencies: filterHbo
            })
          } else {
              this.setState({
                cellFilterDependencies: [...this.state.cellFilterDependencies, {channel: HBO, monthOrYear}, {channel: HBO_MAX, monthOrYear}]
              })
          }
        }
        if (this.state.columnFilterDependencies.includes(monthOrYear.toString())) {
          this.setState({
            columnFilterDependencies: this.state.columnFilterDependencies.filter(el => el !== monthOrYear.toString())
          })
        }
        if (this.state.rowFilterDependencies.includes(channel)) {
          this.setState({
            rowFilterDependencies: this.state.rowFilterDependencies.filter(el => el !== channel)
          })
        }
      }
  }

  _renderOnboarding () {
    if (!this.props.shortcut) {
      return null
    }

    return (
      <MediaPlanningOnBoarding
        name={'Media Planning'}
        run={true}
      />
    )
  }

  render () {
    return (
      <Container fluid={true} className="rightSideContainer audienceContainer">
        <Paper className='paperBase getScreenHeight'>
          {this._renderOnboarding()}
          <Row xl={12} lg={12} md={12} sm={12} className='mediaPlanningWrapper'>
            <Col xl={12}>
              <span>Media Plan</span>
              <OverlayTrigger overlay={<Tooltip id="tooltip">This graph highlights how many titles the selected audience is looking forward to broken out by platform and also by time. A ‘2’ in the row for Netflix and the column for July should be read as: This audience is looking forward to 2 titles that will be released on Netflix in July. The color intensity corresponds to the average affinity score for the titles within the cell, with a darker shade indicating the audience is more favorable toward those titles</Tooltip>} placement="right">
                <img src="/static/images/info.png" alt="info" className="cardInfo" />
              </OverlayTrigger>
              <p className='subTxt'>A calendar view showing releases across ad-supported platforms</p>
            </Col>
            <Col xl={6} lg={6} md={12} sm={12} id='mediaPlanningCalendarWrapper'>
              <Grid container>
                <Grid item sm={12} className='calendarWrapper'>
                  <MediaPlanningCalendarViewComponent
                    topicMediaPlan={this.props.topicMediaPlan}
                    handleCalendarClick={this.handleCalendarClick}
                    selectedRows={this.state.selectedRows}
                    rowFilterDependencies={this.state.rowFilterDependencies}
                    selectedColumns={this.state.selectedColumns}
                    selectedCells={this.state.selectedCells}
                  />
                </Grid>
              </Grid>
            </Col>
            <Col xl={6} lg={6} md={12} sm={12} id='mediaPlanningTableWrapper'>
              <Grid item sm={12} className='tableWrapper upcoming-wrap'>
                <span>Upcoming titles</span>
                <OverlayTrigger overlay={<Tooltip id="tooltip">The chart below showcases title detail for the selected rows and columns in the graph to the left. If nothing is selected, all anticipatory titles will be listed in descending order by affinity.</Tooltip>} placement="right">
                  <img src="/static/images/info.png" alt="info" className="tableCardInfo" />
                </OverlayTrigger>
                <p className='subTxt'>Title detail for the selected platform(s) and/or time period(s)</p>
                <MediaPlanningTableViewComponent
                  topicMediaPlan={this.props.topicMediaPlan}
                  rowFilterDependencies={this.state.rowFilterDependencies}
                  columnFilterDependencies={this.state.columnFilterDependencies}
                  cellFilterDependencies={this.state.cellFilterDependencies}
                />
              </Grid>
            </Col>
          </Row>
        </Paper>
      </Container>
    )
  }
}

export class MediaPlanningCalendarViewComponent extends React.Component {
  static propTypes = {
    topicMediaPlan: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    handleCalendarClick: PropTypes.func,
    selectedRows: PropTypes.array,
    selectedColumns: PropTypes.array,
    selectedCells: PropTypes.array,
    rowFilterDependencies: PropTypes.array
  }

  render () {
    let recos = (this.props.topicMediaPlan.details || {}).recommendations
    let rowData = TopicHelpers.reformatRecommendations(recos)
    const calendar = TopicHelpers.calendarFormatter(rowData)
    const cellColor = (affinity) => {
      let tileBg = affinity === 0 ? '' : affinity < 30 ? 'calendarCell1' : affinity >= 30 && affinity < 60 ? 'calendarCell2' : affinity >= 60 && affinity < 90 ? 'calendarCell3' : affinity >= 90 && affinity < 120 ? 'calendarCell4' : affinity >= 120 && affinity < 150 ? 'calendarCell5' : affinity >= 150 ? 'calendarCell6' : ''
      return tileBg
    }
    const StyledTableCell = withStyles(() => ({
      head: {
        background: '#F4F5F6',
        color: '#808184',
        cursor: 'pointer'
      },
      body: {
        background: '#F4F5F6'
      }
    }))(TableCell)

    const handleClick = (event, index, key) => {
      if (event.target.innerText !== '') {
        this.props.handleCalendarClick(event, index, key)
      }
    }

    return (
      <TableContainer className={`${this.props.topicMediaPlan.isFetching && 'containerwithProgress'} calendarContainer`}>
        {this.props.topicMediaPlan.isFetching ?
          <Box className='loadingProgress'>
            <CircularProgress/>
          </Box> :
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {TopicHelpers.mediaPlanningCalendarHeader().map((val, key) => (
                  <StyledTableCell id={key === 2 ? 'joyRideCell' : ''} key={key} onClick={(event) => handleClick(event, 0, key)} className={this.props.selectedColumns && this.props.selectedColumns.includes(key) ? 'selectedCell' : ''}>{val}</StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {
                calendar && calendar.length && calendar.map((row, index) => (
                  <TableRow key={index}>
                    {TopicHelpers.mediaPlanningCalendarBody().map((val, key) => (
                      <StyledTableCell key={key} data-key={`${index}-${key}`}
                        onClick={(event) => handleClick(event, index)} className={`${cellColor(row[val.affinity])} ${this.props.selectedRows && this.props.selectedRows.includes(index) ? 'selectedCell' : ''}  ${this.props.selectedColumns && this.props.selectedColumns.includes(key) ? 'selectedCell' : ''} ${this.props.selectedCells && this.props.selectedCells.includes(`${index}-${key}`) ? 'selectedCell' : ''} ${row[val.value] !== 0 ? 'cursor-pointer' : ''}`}>{row[val.value] === 0 ? '' : row[val.value]}</StyledTableCell>
                    ))}
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>}
      </TableContainer>
    )
  }
}

export class MediaPlanningTableViewComponent extends React.Component {
  static propTypes = {
    topicMediaPlan: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    rowFilterDependencies: PropTypes.array,
    columnFilterDependencies: PropTypes.array,
    cellFilterDependencies: PropTypes.array
  }

  constructor (props) {
    super(props)

    this.state = {
      searchText: '',
      order: 'desc',
      orderBy: PLAN_AFFINITY
    }
    this.searchRef = React.createRef()
  }

  componentDidMount () {
    if (this.state.searchText.length > 0) {
      this.searchRef.current.focus()
    }
  }

  componentDidUpdate () {
    if (this.state.searchText.length > 0) {
      this.searchRef.current.focus()
    }
  }

  handleCalendarRowFilter = (data) => {
    let rows = data.filter(e => {
      return this.props.rowFilterDependencies.includes(e.category)
    })
    return rows
  }

  handleCalendarColumnFilter = (data) => {
    const calendarHeader = TopicHelpers.mediaPlanningCalendarHeader()
    let monthArr = []
    let yearArr = []
    let nextYearArr = []
    let decMonthArr = []
    const currentMonth = new Date().getMonth()
    const currentYear = new Date().getFullYear()
    const nextYear = currentYear + 1
    const lastMonth = calendarHeader[calendarHeader.length - 3]
    const lastRollOverMonth = moment().month(lastMonth).month()
    if (currentMonth >= 6) {
      monthArr = data.filter(e => {
        if (calendarHeader.indexOf(moment(e.active_date).format('MMM')) > calendarHeader.indexOf('Dec')) {
          return this.props.columnFilterDependencies.includes(moment(e.active_date).format('MMM')) && moment(e.active_date).year() === nextYear
        }
        else {
          return this.props.columnFilterDependencies.includes(moment(e.active_date).format('MMM')) && moment(e.active_date).year() === currentYear && moment(e.active_date).month() !== 11
        }
      })
      if (this.props.columnFilterDependencies.includes('Dec')) {
        decMonthArr = data.filter(e => {
          return moment(e.active_date).month() === 11 && moment(e.active_date).date() !== 31 && moment(e.active_date).year() === currentYear
        })
      }
      if (this.props.columnFilterDependencies.includes(currentYear.toString())) {
        yearArr = data.filter(e => {
          return moment(e.active_date).year() === currentYear
        })
      }
      if (this.props.columnFilterDependencies.includes(nextYear.toString())) {
        nextYearArr = data.filter(e => {
          if (currentMonth === 6) {
            return new Date(e.active_date).getFullYear() === nextYear
          }
          else {
            return new Date(e.active_date).getFullYear() === nextYear && new Date(e.active_date).getMonth() > lastRollOverMonth
          }
        })
      }
    }
    if (currentMonth < 6) {
      monthArr = data.filter(e => {
        return this.props.columnFilterDependencies.includes(moment(e.active_date).format('MMM')) && moment(e.active_date).year() === currentYear
      })
      if (this.props.columnFilterDependencies.includes(currentYear.toString())) {
        yearArr = data.filter(e => {
          return moment(e.active_date).year() === currentYear
        })
      }
      if (this.props.columnFilterDependencies.includes(nextYear.toString())) {
        nextYearArr = data.filter(e => {
          return new Date(e.active_date).getFullYear() === nextYear
        })
      }
    }
    const rows = [...monthArr, ...decMonthArr, ...yearArr, ...nextYearArr]
    return rows
  }

  handleCalendarCellFilter = (data) => {
    const currentYear = new Date().getFullYear()
    const nextYear = currentYear + 1
    const currentMonthInNum = moment(new Date()).format('MM')
    let monthInNum
    let year
    let rows = data.filter(e =>
      this.props.cellFilterDependencies.some(el => {
        monthInNum = moment(e.active_date).format('MM')
        year = new Date(e.active_date).getFullYear()
        if (el.channel === e.category && el.monthOrYear !== nextYear && el.monthOrYear !== currentYear) {
          // DWA-3169 logic
          if (el.channel === e.category && el.monthOrYear === moment(e.active_date).format('MMM') && monthInNum == 12 && year == currentYear && DateHelpers.isYearEndDate(moment(DateHelpers.getDateWithoutTime(e.active_date))) && !DateHelpers.isCurrentMonthPastOctober()) {
            return el.channel === e.category && (el.monthOrYear === moment(e.active_date).format('MMM')) && el.monthOrYear !== nextYear && el.monthOrYear !== currentYear && (moment(e.active_date).month() !== 11) && (moment(e.active_date).date() !== 31)
          } else {
          // check and return if current month greater than June currentMonthInNum > 6, to check condition for months of next year
            return el.channel === e.category && (el.monthOrYear === moment(e.active_date).format('MMM') && ((currentMonthInNum <= monthInNum && year == currentYear) || (currentMonthInNum > monthInNum && year == nextYear)))
          }
        }
        if (el.channel === e.category && el.monthOrYear !== nextYear && el.monthOrYear === currentYear) {
          return el.channel === e.category && new Date(e.active_date).getFullYear() === currentYear
        }
        if (el.channel === e.category && el.monthOrYear === nextYear && el.monthOrYear !== currentYear) {
          return el.channel === e.category && (el.monthOrYear === new Date(e.active_date).getFullYear())
        }
      })
    )
    return rows
  }

  descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy] || b[orderBy] === null) {
      return -1
    }
    if (b[orderBy] > a[orderBy] || a[orderBy] === null) {
      return 1
    }
    return 0
  }
  getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -this.descendingComparator(a, b, orderBy)
  }

  sortData = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0])
      if (order !== 0) return order
      return a[1] - b[1]
    })
    return stabilizedThis.map((el) => el[0])
  }

  onSearchTextChange = (e) => {
    this.setState({searchText: e.target.value})
    this.searchRef.current.focus()
  }

  sortHandler = (property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc'
    this.setState({order: isAsc ? 'desc' : 'asc', orderBy: property})
  }
  nameWithTooltip = (name) => {
    const strLimit = 40
    let limit = strLimit
    const strArr = name.split(' ')
    if (strArr.length >= 7) {
      limit = (name.length > strLimit && strArr.length <= 7) ? name.indexOf(strArr[6]) : name.indexOf(strArr[7])
    }
    if (name.length > strLimit || strArr.length > 7) {
      const tooltip = <Tooltip id="tooltip">{name}</Tooltip>
      return (
        <OverlayTrigger overlay={tooltip} placement='bottom'>
          <span className="txt">{name.substring(0, limit)}...</span>
        </OverlayTrigger>
      )
    }
    return (<span>{name}</span>)
  }

  render () {
    let recos = (this.props.topicMediaPlan.details || {}).recommendations
    const data = TopicHelpers.reformatRecommendations(recos)
    const {rowFilterDependencies, columnFilterDependencies, cellFilterDependencies} = this.props
    const StyledTableCell = withStyles(() => ({
      head: {
        background: '#F4F5F6'
      }
    }))(TableCell)
    const style = {
      width: 30,
      height: 30,
      borderRadius: 3
    }
    let rows = data && data.length && data
    let cellFilteredData = rows && rows.length && cellFilterDependencies.length ? this.handleCalendarCellFilter(rows) : []
    let rowFilteredData = rows && rows.length && rowFilterDependencies.length ? this.handleCalendarRowFilter(rows) : []
    let columnFilteredData = rows && rows.length && columnFilterDependencies.length ? this.handleCalendarColumnFilter(rows) : []
    rows = rowFilterDependencies.length || columnFilterDependencies.length || cellFilterDependencies.length ? [...new Set([...rowFilteredData, ...columnFilteredData, ...cellFilteredData])] : rows
    rows = this.state.searchText.length > 0 ? rows.filter(e => e.topic_name.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1) : rows
    return (
      <TableContainer className={`${this.props.topicMediaPlan.isFetching && 'containerwithProgress'} tableView`} id="upcoming-table">
        {this.props.topicMediaPlan.isFetching ?
          <Box className='loadingProgress'>
            <CircularProgress/>
          </Box> :
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell>&nbsp;</StyledTableCell>
                <StyledTableCell>&nbsp;</StyledTableCell>
                <StyledTableCell>
                  <input type="text" name="name" placeholder="Title" className="nameInput" autoComplete="off" ref={this.searchRef} value={this.state.searchText} onChange={this.onSearchTextChange}/>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={this.state.orderBy === PLAN_TYPE}
                    direction={this.state.order}
                    onClick={()=>this.sortHandler(PLAN_TYPE)}
                  >
                    Type
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={this.state.orderBy === PLAN_PLATFORM}
                    direction={this.state.order}
                    onClick={()=>this.sortHandler(PLAN_PLATFORM)}
                  >
                    Platform
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={this.state.orderBy === PLAN_GENRE}
                    direction={this.state.order}
                    onClick={()=>this.sortHandler(PLAN_GENRE)}
                  >
                    Genre
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={this.state.orderBy === PLAN_PREMIERE}
                    direction={this.state.order}
                    onClick={()=>this.sortHandler(PLAN_PREMIERE)}
                  >
                    Premiere
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={this.state.orderBy === PLAN_AFFINITY}
                    direction={this.state.order}
                    onClick={()=>this.sortHandler(PLAN_AFFINITY)}
                  >
                    Affinity
                  </TableSortLabel>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                rows && rows.length > 0 && this.sortData(rows, this.getComparator(this.state.order, this.state.orderBy)).map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.row_id}</TableCell>
                    <TableCell align="left">
                      <Thumbnail
                        entityOverrideImage={(row.entity_override_image && row.entity_override_image.indexOf('http') === -1) ? row.entity_override_image : null}
                        thumbnail={(row.thumbnail && row.thumbnail.indexOf('http') > -1) ? row.thumbnail : null}
                        name={row.topic_name || row.topic_search_name}
                        imageDivStyle={style}
                        noImgTextClass={'aaNoImgText'}
                        noImgClass={'aaNoImg'}
                        divId={`content_preference_${index}`}
                      />
                    </TableCell>
                    <TableCell>{this.nameWithTooltip(row.topic_name)}</TableCell>
                    <TableCell>{row.topic_subtype}</TableCell>
                    <TableCell>{row.category}</TableCell>
                    <TableCell>{row.genre}</TableCell>
                    <TableCell>{DateHelpers.formatMediaPlanningDate(row.active_date)}</TableCell>
                    <TableCell>{TableFormats.formatRelevancyNumber(row.score)}</TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>}
      </TableContainer>
    )
  }
}
